
import React from 'react';

const Footer = () => {
  const currentYear = 2025;
  
  return (
    <footer className="bg-primary/5 py-4 sm:py-6 mt-8 sm:mt-12">
      <div className="container mx-auto px-3 sm:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-3 md:mb-0">
            <p className="text-xs sm:text-sm text-gray-600">
              &copy; {currentYear} All-Star Basketball and Physical Training Academy. All rights reserved.
            </p>
          </div>
          <div>
            <p className="text-xs sm:text-sm text-gray-600">
              Website created by B The Entrepreneur AI Consulting
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
